<micro-select-combo #sel
              placeholder="Credential Type"
              [mode]="mode"
              [(id)]="authType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>

